import React, {useEffect,useState} from 'react';
import InputForm  from '../../InputT';
import axios from 'axios';
import {useTranslation } from 'react-i18next';
import SweetAlert from 'sweetalert2';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Box, Grid } from '@mui/material';
import SearchInput from '../../SearchInput';
import SearchModal   from '../../SearchModal';

  // //Initialisation des parametres de recherche
   let searchClient:ParamsPicklist= {CodeAgence:'M',Table: "CLIENT",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:'typcli',Choix:22}
  // let searchTitre :ParamsPicklist={CodeAgence:'',Table: "TITRES",Colonne1:"CDTITR",Colonne2:"LIBELL1",Colagence:'101',Choix:22}
  // let searchGestionnaire :ParamsPicklist={CodeAgence:'',Table: "GESTIONNAIRE",Colonne1:"CODGES",Colonne2:"LIBELLE",Colagence:'',Choix:22}
  // let searchJuridique :ParamsPicklist={CodeAgence:'',Table: "JURIDI",Colonne1:"CDFJPM",Colonne2:"LIBELL",Colagence:'101',Choix:22}
  // //let searchProspect :ParamsPicklist={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'',Choix:22}
  // let searchClassRisque:ParamsPicklist={CodeAgence:'',Table: "CLARIS",Colonne1:"CLARIS",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
  // let searchPays :ParamsPicklist={CodeAgence:'',Table: "CDPAYS",Colonne1:"CDPAYS",Colonne2:"LIBELL",Colagence:'101',Choix:22}
  // let searchdmar :ParamsPicklist={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'101',Choix:22}
  // let searchActivite :ParamsPicklist={CodeAgence:'',Table: "TABNAE",Colonne1:"CODNAE",Colonne2:"LIBELL",Colagence:'101',Choix:22}
  // let searchUniteInstitutionnel :ParamsPicklist={CodeAgence:'',Table: "TABNUI",Colonne1:"CODNUI",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
  // let searchZoneGeo:ParamsPicklist={CodeAgence:'',Table: "RESIDE",Colonne1:"CDRESI",Colonne2:"LIBELLFR",Colagence:'101',Choix:22} 

  //Initialisation des parametres de recherche
    //let searchClient:ParamsPicklist= {CodeAgence:user.codage,Table: "view_AnyAllClient",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:"CODAGE",colfiltre:"TYPCLI",valfiltre:'M',Choix:22}
    let searchTitre :ParamsPicklist={CodeAgence:'',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'',colfiltre:'RUBRIQ',valfiltre:'TITRESCLIENT',Choix:22}
    let searchGestionnaire :ParamsPicklist={CodeAgence:'',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'',colfiltre:'RUBRIQ',valfiltre:'GESTIONNAIRE',Choix:22}
    //let searchGestionnaire :ParamsPicklist={CodeAgence:'GESTIONNAIRE',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'RUBRIQ',Choix:22}
  
    let searchJuridique :ParamsPicklist={CodeAgence:'',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'',colfiltre:'RUBRIQ',valfiltre:'FORMEJURIDIQUE',Choix:22}
    //let searchProspect :ParamsPicklist={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'',Choix:22}
    let searchClassRisque:ParamsPicklist={CodeAgence:'',Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'',colfiltre:'RUBRIQ',valfiltre:'CLASSERISQUE',Choix:22}
    //let searchPays :ParamsPicklist={CodeAgence:'',Table: "CDPAYS",Colonne1:"CDPAYS",Colonne2:"LIBELL",Colagence:'CDFJPM',Choix:22}
      let searchPays: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'PAYS', Choix: 22 }
    
    //let searchdmar :ParamsPicklist={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'CDFJPM',Choix:22}
     let searchdmar: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'DEMARCHEUR', Choix: 22 }
     
    //let searchActivite :ParamsPicklist={CodeAgence:'',Table: "TABNAE",Colonne1:"CODNAE",Colonne2:"LIBELL",Colagence:'CDFJPM',Choix:22}
     let searchActivite: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ACTIVITE', Choix: 22 }
     
    //let searchUniteInstitutionnel :ParamsPicklist={CodeAgence:'',Table: "TABNUI",Colonne1:"CODNUI",Colonne2:"LIBELL",Colagence:'CDFJPM',Choix:22} 
     let searchUniteInstitutionnel: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'UNITEINSTITUTIONNELLE', Choix: 22 }
    
    //let searchZoneGeo:ParamsPicklist={CodeAgence:'',Table: "RESIDE",Colonne1:"CDRESI",Colonne2:"LIBELLFR",Colagence:'CDFJPM',Choix:22} 
   let searchZoneGeo: ParamsPicklist = { CodeAgence: '', Table: "LIB", Colonne1: "CODLIB", Colonne2: "LIBELL", Colagence: '',colfiltre:'RUBRIQ',valfiltre:'ZONEGEOGRAPHYQUE', Choix: 22 }
  
const Tab1 = (props:{etatG?:boolean,form?:any,Function?:Function}) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const {t,i18n}=useTranslation();
  const [loading, setLoading] = useState(false);

    //vérification de la date de naissance qui doit etre supérieur à la date actuel
    const handleChangedatenais = (e: any) => {
      const DatteActuel = new Date().toISOString();
  
      if (e.target.value >= DatteActuel) {
        SweetAlert.fire({ title: "saisie invalide", text: "La date saisie est Supérieure à la Actuelle", icon: "error" });
        props.form.setFieldValue("DATNAI", '');
      }
  
    };

  //information du client
  let informationclient= {
    SearchClient:{ 
      Titre:t("FormClientMoral.informationclient.SearchClient.Titre"), 
      label:t("FormClientMoral.informationclient.SearchClient.label"),
       name:"NUMCLI", params:searchClient
      },
      InputCle:{ 
        label:"Lettre Clé", 
        name:"CLECLI"
        },  
    SearchTitre:{ 
      Titre:t("FormClientMoral.informationclient.SearchTitre.Titre"), 
      label:t("FormClientMoral.informationclient.SearchTitre.label"),
      name:"TITCLI", params:searchTitre
        }, 
    InputRaisonSociale:
      { 
      label:'Raison Sociale', 
      name:"NOMCLI"
    //suspend  
    },
      InputRegistreCommerce:
      { 
      label:'Régistre Commerce', 
      name:"REGCOM"
      },
    InputDateConstitution:{ 
        label:"Date Constitution", 
        name:"DATNAI"
         }, 
    InputDureeVie:{ 
      label:"Durée Vie", 
      name:"DIRVIE"
      },     
    SearchNationnalite:{ 
        Titre:"Recherche Nationnalité", 
        label:"Nationnalité",
        name:"CDPAYS", params:searchPays
          },
    SearchGestionnaire:{ 
      Titre:"Recherche Gestionnaire", 
      label:"Gestionnaire",
      name:"CDGEST", params:searchGestionnaire
        },      
    SearchFormeJuridique:{ 
        Titre:"Recherche Forme Juridique", 
        label:"Forme Juridique",
        name:"CDFJPM", params:searchJuridique 
        //suspend
      }, 
    SearchUniteI:{ 
        Titre:" Recherche Unité Institutionnelle", 
        label:"Unité Institutionnelle",
        name:"CDENUI", params:searchUniteInstitutionnel 
      },  
    InputNomPromoteur:{ 
      label:"Nom du Promoteur", 
      name:"PRECLI"
      },
    InputSigle:{ 
        label:"Sigle", 
        name:"sigle"
        },
    InputNumeroContrubuable:{ 
      label:"N° Constribuable", 
      name:"NOCONT"
      },    
    InputLieuConstitution:
       { 
        label:"Lieu Constitution", 
        name:"LIENAI"
        },
  SearchZoneGeo:{ 
    Titre:"Recherche Zone Geographique", 
    label:"Zone Géographique",
    name:"RESIDE", params:searchZoneGeo
       
   }   ,  
   SearchDemarcheur:{ 
    Titre:"Rechercher Demarcheur", 
    label:"Demarcheur",
    name:"coteprod", params:searchdmar
 
  },
  SearchActivite:{ 
    Titre:"Recherche Activité Economique", 
    label:"Activité Economique",
    name:"CDENAE", params:searchActivite
  }, 
  SearchClaris:{ 
    Titre:"Recherche Classification Risque", 
    label:"Classification Risque",
    name:"CLARIS", params: searchClassRisque
  },                                                                       
  }  
 


         
    
 return(
  
  <div className='tabItem' >
    <Grid container className='border' sx={{ width: "85%", position: "absolute" }}>
      <Grid item xs={12} md={6} className='border-left'>
          <SearchInput dissabledCode={true} notRequired form={props.form} width={9}  Titre={informationclient.SearchClient.Titre}  label={informationclient.SearchClient.label} name={informationclient.SearchClient.name}   Parametre={informationclient.SearchClient.params}   />
          <SearchModal  disabled={true} form={props.form} width={9}    Titre={informationclient.SearchTitre.Titre}   label={informationclient.SearchTitre.label} name={informationclient.SearchTitre.name}    Parametre={informationclient.SearchTitre.params} />
          <InputForm  disabled={true} width={9}    label={informationclient.InputRaisonSociale.label} name={informationclient.InputRaisonSociale.name}     type='text'  />
          <InputForm  disabled={true}   width={9}    label={informationclient.InputRegistreCommerce.label} name={informationclient.InputRegistreCommerce.name}     type='text'  />
          <InputForm  disabled={true}   width={9}   label={informationclient.InputDateConstitution.label} name={informationclient.InputDateConstitution.name}  onChange={handleChangedatenais}    type='date'  />
          <InputForm  disabled={true}   width={9}   label={informationclient.InputDureeVie.label} name={informationclient.InputDureeVie.name}     type='number'  />
          <SearchModal  disabled={true} form={props.form} width={9}  Titre={informationclient.SearchNationnalite.Titre}   label={informationclient.SearchNationnalite.label} name={informationclient.SearchNationnalite.name}    Parametre={informationclient.SearchNationnalite.params} />
          <SearchModal  disabled={true} form={props.form} width={9}  Titre={informationclient.SearchGestionnaire.Titre}   label={informationclient.SearchGestionnaire.label} name={informationclient.SearchGestionnaire.name}    Parametre={informationclient.SearchGestionnaire.params} />
          <SearchModal  disabled={true} form={props.form} width={9}  Titre={informationclient.SearchFormeJuridique.Titre}   label={informationclient.SearchFormeJuridique.label} name={informationclient.SearchFormeJuridique.name}    Parametre={informationclient.SearchFormeJuridique.params} />

      </Grid> 
      <Grid item xs={12} md={6} className='border-left'>
            {/* <InputForm  disabled={true}    width={9}   label={informationclient.InputCle.label}    name={informationclient.InputCle.name}  type='text' />    */}
            <InputForm  disabled={true}    width={9}   label={informationclient.InputNomPromoteur.label}    name={informationclient.InputNomPromoteur.name}  type='text' />
            <InputForm  disabled={true}    width={9}   label={informationclient.InputSigle.label}    name={informationclient.InputSigle.name}  type='text' />
            <InputForm  disabled={true}    width={9}   label={informationclient.InputNumeroContrubuable.label}    name={informationclient.InputNumeroContrubuable.name}  type='text' />
            <InputForm  disabled={true}    width={9}   label={informationclient.InputLieuConstitution.label}    name={informationclient.InputLieuConstitution.name}  type='text' />
            <SearchModal  disabled={true} form={props.form}   width={9}  Titre={informationclient.SearchZoneGeo.Titre}   label={informationclient.SearchZoneGeo.label} name={informationclient.SearchZoneGeo.name}    Parametre={informationclient.SearchZoneGeo.params} />
            <SearchModal  disabled={true} form={props.form}   width={9}  Titre={informationclient.SearchDemarcheur.Titre}   label={informationclient.SearchDemarcheur.label} name={informationclient.SearchDemarcheur.name}    Parametre={informationclient.SearchDemarcheur.params} />
            <SearchModal  disabled={true} form={props.form}   width={9}  Titre={informationclient.SearchActivite.Titre}   label={informationclient.SearchActivite.label} name={informationclient.SearchActivite.name}    Parametre={informationclient.SearchActivite.params} />
            <SearchModal  disabled={true} form={props.form}   width={9}  Titre={informationclient.SearchClaris.Titre}   label={informationclient.SearchClaris.label} name={informationclient.SearchClaris.name}    Parametre={informationclient.SearchClaris.params} />
            <SearchModal  disabled={true} form={props.form} width={9}  Titre={informationclient.SearchUniteI.Titre}   label={informationclient.SearchUniteI.label} name={informationclient.SearchUniteI.name}    Parametre={informationclient.SearchUniteI.params} />
      </Grid>  
      
    </Grid>
  </div>
  );
}

export default Tab1;